import {Language} from '../../shared/model/language';

export const LANGUAGE_ARRAY = [
  new Language('gb', 'English', true),
  new Language('de', 'German'),
  new Language('ar', 'Arabic'),
  new Language('us', 'US-English')
];
